<main class="main-wrap-ng">
  <div class="content-blk">
    <div class="container-fluid">
      <div class="dash-head">
      	<div class="row">
      		<div class="col-sm-4">
				<!-- <div class="search-top">
					<div class="srch-flt-rt">
						<mat-checkbox >Select All</mat-checkbox>
					</div>
				</div> -->
		    </div>
		    <div class="col-sm-8">
		    	<div class="search-top text-right">
					<!-- <form  class="example-form" [formGroup] = "searchDesignForm" (ngSubmit)="fn_searchDesign(searchDesignForm)"> -->
						<form  class="example-form" [formGroup] = "searchDesignForm">
						<div class="srch-flt-rt">
							<mat-form-field class="example-full-width">
								<input matInput placeholder="Search" formControlName="searchDesign" ng-model-options="{debounce: 10000}" (change)="fn_searchDesign(searchDesignForm)">
								<!-- <mat-error *ngIf="!f.searchDesign.valid && f.searchDesign.touched && (f.searchDesign.pristine || f.searchDesign.dirty)">
								<strong>required</strong>
								 </mat-error> -->
							</mat-form-field>
							<!-- <button mat-raised-button class="mat-btn" [disabled]="searchDesignForm.invalid" >Search</button> -->
			      		</div>
					</form>
			      </div>
		    </div>
	    </div>
      </div>    
      
      <div class="search-wrap" >
      	<div class="row search-results"
		  infiniteScroll
		  [infiniteScrollDistance]="scrollDistance"
		  [infiniteScrollThrottle]="throttle"
		  (scrolled)="fn_getUploadedDesigns()">
  			<div class="col-sm-6 col-md-4 col-lg-3 align-items-center spc-btm-30">
  				<div class="search-grid upld-fl-wrp" (click)="openDialog()">
  					<div class="upld-fl-in">
						<svg height="512pt" viewBox="-11 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m245.332031 405.332031c-5.886719 0-10.664062-4.777343-10.664062-10.664062v-384c0-5.890625 4.777343-10.667969 10.664062-10.667969 5.890625 0 10.667969 4.777344 10.667969 10.667969v384c0 5.886719-4.777344 10.664062-10.667969 10.664062zm0 0"/><path d="m373.332031 149.332031c-2.730469 0-5.460937-1.042969-7.550781-3.113281l-120.449219-120.46875-120.445312 120.46875c-4.160157 4.160156-10.925781 4.160156-15.085938 0-4.15625-4.160156-4.15625-10.921875 0-15.082031l128-128c4.160157-4.160157 10.925781-4.160157 15.085938 0l128 128c4.160156 4.160156 4.160156 10.921875 0 15.082031-2.09375 2.070312-4.824219 3.113281-7.554688 3.113281zm0 0"/><path d="m480 512h-469.332031c-5.890625 0-10.667969-4.777344-10.667969-10.667969v-106.664062c0-5.890625 4.777344-10.667969 10.667969-10.667969 5.886719 0 10.664062 4.777344 10.664062 10.667969v96h448v-96c0-5.890625 4.78125-10.667969 10.667969-10.667969s10.667969 4.777344 10.667969 10.667969v106.664062c0 5.890625-4.78125 10.667969-10.667969 10.667969zm0 0"/></svg>
						<p>Upload more photo or drag image here</p>
					</div>
  				</div>
  			</div>
      	
  			<!-- REPEAT -->
  			<div class="col-sm-6 col-md-4 col-lg-3  spc-btm-30" *ngFor="let design of designs">
  				<div class="search-grid">
  					<div class="search-thumb">
						  <img class="ban-ht-wrp" id="blah" [src]="design.UploadedBase64FileUrl || 'http://placehold.it/180'" alt="design image" height="200"/> 
  						<!-- <div class="menu-edit">
							<mat-checkbox  matTooltip="Select" ></mat-checkbox>  							
  						</div>  						 -->
  						<div class="menu-bar">
							<button mat-icon-button [matMenuTriggerFor]="menu">
							<mat-icon>more_vert</mat-icon>
							</button>
							<mat-menu #menu="matMenu" xPosition="before">
							<button mat-menu-item (click)="openDesignEditDialog(design.UploadedDesignId)">
											<mat-icon>edit</mat-icon>
											<span>Edit</span>
							</button>
							<button *ngIf="design.IsCustomizable" mat-menu-item (click)="openConfirmationDialog(design.UploadedDesignId)"> 
								<mat-icon>delete_outline</mat-icon>
								<span>Delete</span>
							</button>
							<button mat-menu-item [routerLink]="[ '/store/designs/apply' ]">
									<mat-icon>done</mat-icon>
								<span>Apply</span>
							</button>
							</mat-menu>	
						</div> 
						  
  					</div>
  					<div class="search-content">
  						<h4>{{design.DesignName}}</h4>
  					</div>
  				</div>
  			</div>
  			<!-- /REPEAT -->
  			
      	</div>
      </div>
    </div>
  </div>
  </main>